var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursorClickStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Cursor-Click--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Cursor Click Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cursor-click"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector 588",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.9896428571428573 9.778855885714286 4.4378586 1.1891166857142859",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector 589",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.8743652142857146 20.4563406 3.2487419142857146 -3.2487419142857146",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector 591",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.778537542857144 1.9896428571428573 1.1891166857142859 4.4378586",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector 592",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.45602225714286 3.8746835571428573 17.207280342857143 7.123425471428572",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    d: "M12.7295493 14.458681585714288C12.332602285714286 18.706356857142858 13.6530354 27.323102142857145 19.490276142857144 34.34282742857143c0.9048365142857143 1.0879367142857144 2.390781385714286 0.9871281428571429 2.957405142857143 -0.3098537142857143 0.6408241714285715 -1.4664994285714286 1.3139866714285715 -3.386372142857143 1.8569204142857143 -5.0414897142857145l5.1882723 5.188458000000001c1.2940637142857143 1.2940637142857143 3.3922084285714287 1.2940637142857143 4.686272142857143 0 1.294329 -1.2940637142857143 1.294329 -3.3922084285714287 0.0002652857142857143 -4.6865374285714285l-5.188458000000001 -5.188431471428571c1.6553828571428573 -0.5429337428571429 3.5752555714285714 -1.2161493 5.041755 -1.8569734714285715 1.2969818571428573 -0.5666237571428572 1.3977904285714287 -2.0525951571428576 0.3095884285714286 -2.957431671428572 -7.0194600000000005 -5.837214214285714 -15.636284871428572 -7.1576473285714295 -19.883933614285716 -6.760700314285715 -0.9296142000000001 0.08688107142857143 -1.6419328714285715 0.7991997428571428 -1.728813942857143 1.728813942857143Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.7295493 14.458681585714288C12.332602285714286 18.706356857142858 13.6530354 27.323102142857145 19.490276142857144 34.34282742857143c0.9048365142857143 1.0879367142857144 2.390781385714286 0.9871281428571429 2.957405142857143 -0.3098537142857143 0.6408241714285715 -1.4664994285714286 1.3139866714285715 -3.386372142857143 1.8569204142857143 -5.0414897142857145l5.1882723 5.188458000000001c1.2940637142857143 1.2940637142857143 3.3922084285714287 1.2940637142857143 4.686272142857143 0 1.294329 -1.2940637142857143 1.294329 -3.3922084285714287 0.0002652857142857143 -4.6865374285714285l-5.188458000000001 -5.188431471428571c1.6553828571428573 -0.5429337428571429 3.5752555714285714 -1.2161493 5.041755 -1.8569734714285715 1.2969818571428573 -0.5666237571428572 1.3977904285714287 -2.0525951571428576 0.3095884285714286 -2.957431671428572 -7.0194600000000005 -5.837214214285714 -15.636284871428572 -7.1576473285714295 -19.883933614285716 -6.760700314285715 -0.9296142000000001 0.08688107142857143 -1.6419328714285715 0.7991997428571428 -1.728813942857143 1.728813942857143Z",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorClickStreamlineFlex);
export default __webpack_public_path__ + "static/media/Cursor-Click--Streamline-Flex.283a4212c87f82658ed248dade1b8ac7.svg";
export { ForwardRef as ReactComponent };